/* eslint-disable react/no-danger */
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from '../EcsPortal.module.scss';
import styles2 from '../../../styles/Accordion.module.scss';
import styles3 from './Faq.module.scss';
import BannerCategory from '../BannerCategory';
import BannerFrameDeliveryStatus from '../BannerFrameDeliveryStatus';
import BannerRedirection from '../BannerRedirection';
import LinkWebsiteInput from '../LinkWebsiteInput';
import useAlert from '../../../hooks/useAlert';
import {
  bannerNotSignedListObj,
  CheckingValidSearch,
  defaultEnableBtnStyles,
  getContractTypeVal,
  getSourceValue,
  handleRedirection,
} from '../../../lib/common';
import { handleLoginPopup, handleSetFaqData } from '../../../reducersAndActions/actions/appStateActions';
import FaqTicketCreate from '../../common/FaqTicketCreate';
import { useAuth } from '../../../contexts/auth';
import { useAppState } from '../../../contexts/appState';
import Certificate from '../JDRRCertificate/Certificate';
import { handleImpressionsTrack } from '../../../api';

export default function BannerFaqs({
  faqdetails,
  bannerData,
  setBannerData,
  searchQuestion,
  handleSearchFaq,
  hLinkResp,
  setHLinkResp,
  activeIndex,
  setActiveIndex,
  projectId,
  handleBannerRedirection,
}) {
  const [authState] = useAuth();
  const { selectedBusiness, type } = authState;
  const [appState, appDispatch] = useAppState();
  const [setAlert] = useAlert();
  const content = useRef(null);
  const source = getSourceValue();
  const getBannerType = sessionStorage.getItem('bannerType');
  const navigate = useNavigate();
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio')) || {};
  const contractVal = getContractTypeVal(projectId);

  useEffect(() => {
    document.body.style.overflow = 'unset';
  }, []);

  const validSearchValue = CheckingValidSearch(searchQuestion);

  const handleFaqChange = async (faqObj, index) => {
    setActiveIndex(index === activeIndex ? -1 : index);
    if (activeIndex !== index) {
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = `faq_${faqObj?.faqKey}`;
        const faqTypeVal = '';
        const othersData = [];
        const bannerTrackType =
          getBannerType === 'Mobile Banner' ? 'mobile' : getBannerType === 'JDRR Certificate' ? 'jdrr' : 'web';
        const llTrd = `issue_${bannerTrackType}banner`;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
    }
    if (hLinkResp) {
      handleSetFaqData(appDispatch, {
        faqData: [],
      });
    }
    setHLinkResp('');
  };

  const handleBannerRedirect = async () => {
    if (projectId === 'csportal') {
      const bannerTrackType =
        getBannerType === 'Mobile Banner'
          ? 'mobilebanner'
          : getBannerType === 'JDRR Certificate'
            ? 'jdrrCertificate'
            : 'webbanner';
      const liVal = 'click';
      const liTrd = `cta_clickhere`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_${bannerTrackType}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);

      if (getBannerType === 'JDRR Certificate') {
        const redirectionUrl = `https://www.justdial.com/BNR-${
          selectedBusiness?.shorturl || ''
        }?hide_header=1&support=1&source=${source}`;
        handleRedirection(source, redirectionUrl);
      } else {
        handleBannerRedirection();
      }
    }
  };

  const bannerNotSignedList =
    getBannerType === 'Mobile Banner'
      ? bannerNotSignedListObj[projectId].mobileBannerNotSignedList
      : getBannerType === 'JDRR Certificate'
        ? bannerNotSignedListObj[projectId].jdrrBannerNotSignedList
        : bannerNotSignedListObj[projectId].webBannerNotSignedList;

  const handleTicketCreate = () => {
    sessionStorage.removeItem('faq');
    if (projectId === 'csportal') {
      if (appState?.loginPopup?.nonlogin && !type) {
        handleLoginPopup(appDispatch, { ...appState.loginPopup, open: true, click: true });
        return '';
      }
    }
    const parentid = projectId === 'csportal' ? selectedBusiness?.parentid : selectedBusinessGenio?.parentId;
    const city = projectId === 'csportal' ? selectedBusiness?.data_city : selectedBusinessGenio?.city;

    if (parentid && city) {
      if (projectId === 'csportal' && ['paid', 'expiredShort'].includes(contractVal)) {
        navigate(`/csportal/create_ticket?parentId=${parentid}&city=${city}
        &key=${getBannerType}&vertical=''`);
      } else {
        navigate(
          `/${projectId}/create_ticket?parentId=${parentid}&city=${city}
        &key=${getBannerType}&vertical=''`,
        );
      }
    } else if (appState?.loginPopup?.nonlogin && projectId === 'csportal') {
      handleLoginPopup(appDispatch, { ...appState.loginPopup, open: true, click: true });
    }
    return '';
  };

  const raiseTicketBtnView = () => (
    <section className="csraiseticket">
      <div
        className={`raiseticketwrp text_center ${
          projectId === 'genio' && bannerData && bannerData?.bannerNotSigned ? 'pt-10' : 'pt-40'
        } pl-20 pr-20`}
      >
        <div className="font12 fw600 color777 pb-10">Didn&apos;t get a solution to your concern?</div>
        <button
          type="button"
          className={`${styles2.Accordion__Contant__Button} bluefill_animate font12 fw600 colorFFF mt-10`}
          style={defaultEnableBtnStyles}
          onClick={() => {
            handleTicketCreate();
          }}
        >
          Raise a Ticket
        </button>
      </div>
    </section>
  );
  return (
    <div>
      {bannerData && bannerData?.bannerNotSigned ? (
        <>
          {projectId === 'csportal' && getBannerType === 'JDRR Certificate' ? (
            <Certificate />
          ) : (
            <div className="p-20">
              <div className="font12 fw600 color111">
                {projectId === 'csportal'
                  ? getBannerType === 'JDRR Certificate'
                    ? `This campaign is not signed by you.Make a strong impression on walk in customers by placing JD's review & ratings certificate at your premises!`
                    : `This campaign is not signed by you.Unleash Your Brand's Potential - Stand Out, Shine Bright!`
                  : 'This campaign is not signed up the vendor.'}
              </div>
              <div className="font12 fw600 color111 mt-5">
                {projectId === 'csportal' ? 'Benefits :' : 'Vendor gets :'}
              </div>
              <ul id="bannerList" className="p-20">
                {bannerNotSignedList.map((each, idx) => (
                  <li style={{ listStyleType: 'disc' }} className="font12 fw500 color111" id="bannerListItem" key={idx}>
                    <div
                      aria-label="banner_faq_click"
                      tabIndex={0}
                      role="button"
                      onKeyDown={() => {}}
                      onClick={() => handleBannerRedirect()}
                      dangerouslySetInnerHTML={{
                        __html:
                          idx === 2 && projectId === 'csportal'
                            ? each.replace(
                                'CLICK HERE',
                                '<span style="color:blue" class="highlightClickable font12 fw500 color111">CLICK HERE</span>',
                              )
                            : each,
                      }}
                    />
                  </li>
                ))}
              </ul>
            </div>
          )}
          {projectId === 'genio' && raiseTicketBtnView()}
        </>
      ) : (
        <div className="p-20">
          <div className={`${styles3.Faq_Heading} font16 fw600 color111 text_center mt-5`}>
            Questions? We&apos;ve got instant answers
          </div>

          <div className={`${styles3.Faq__Search} mt-25`}>
            <input
              className={`${styles3.Faq__Input} font13 fw500 color111`}
              type="text"
              placeholder="Search for keywords..."
              onChange={handleSearchFaq}
              value={searchQuestion}
            />
          </div>
          {!validSearchValue && searchQuestion && (
            <span className="colorEC4 font12">Please avoid special characters.</span>
          )}
          <div className={`${styles2.Accordion__Box}`}>
            <div className={`${styles2.Accordion__Pannel} `}>
              <>
                {faqdetails &&
                  faqdetails.map((item, index) => {
                    return (
                      <div key={index}>
                        <div
                          aria-label="bannerFaq_change"
                          tabIndex={0}
                          role="button"
                          onKeyDown={() => {}}
                          className={`${styles2.Accordion__Pannel__Heading} ${
                            activeIndex === index ? styles.Active : ''
                          }`}
                          onClick={() => handleFaqChange(item, index)}
                        >
                          <div className={`${styles2.Accordion__Pannel__Title} font13 fw500 color111`}>
                            {item?.question || ''}
                          </div>
                          <div className={`${styles.Accordion__Pannel__Icon} csicon`} />
                        </div>
                        {index === activeIndex && (
                          <div className={`${styles.Accordion__Contant}`} ref={content} style={{ maxHeight: `0px` }}>
                            <div className={`${styles.Accordion__TextContant}`}>
                              <>
                                {[1, 2, 4, 8, 14, 15, 16].includes(item?.pop) &&
                                item?.data &&
                                Object.keys(item?.data).length > 0 ? (
                                  <>
                                    {item?.pop !== 8 && (
                                      <BannerCategory
                                        data={item?.data}
                                        searchQuestion={searchQuestion}
                                        setAlert={setAlert}
                                        showTicketCreation={[1, 14].includes(item?.pop)}
                                        bannerData={bannerData}
                                        faqId={item?.pop}
                                        projectId={projectId}
                                      />
                                    )}
                                    {item?.pop === 8 && <BannerFrameDeliveryStatus data={item?.data} />}
                                  </>
                                ) : (
                                  <>
                                    {item.pop === 17 ? (
                                      <FaqTicketCreate
                                        ticketCreator="BUSINESS"
                                        issue="Banner related"
                                        subIssue="Categories update"
                                        vertical="LISTING"
                                        category="CS"
                                        hideAlert
                                        hideCrossIcon
                                        faqObj={item}
                                      />
                                    ) : (
                                      ![3, 9, 10, 11, 13, 18, 19, 20].includes(item?.pop) && (
                                        <BannerRedirection projectId={projectId} faqId={item?.pop} faqObj={item} />
                                      )
                                    )}
                                  </>
                                )}

                                {[3, 18].includes(item?.pop) ? (
                                  <>
                                    {hLinkResp ? (
                                      <div className="color777 font14">{hLinkResp || ''}</div>
                                    ) : (
                                      <LinkWebsiteInput
                                        hLink={item?.hLink || ''}
                                        bannerData={bannerData}
                                        setBannerData={setBannerData}
                                        setHLinkResp={setHLinkResp}
                                        projectId={projectId}
                                      />
                                    )}
                                  </>
                                ) : (
                                  <div id="banner-faq-list" dangerouslySetInnerHTML={{ __html: item.ans }} />
                                )}
                              </>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </>
            </div>
          </div>
          {((getBannerType === 'Web Banner' && bannerData?.showWebBannerInProgressImage) ||
            (getBannerType === 'Mobile Banner' && bannerData?.mobileBannerStatus === 'Pending')) &&
            raiseTicketBtnView()}
        </div>
      )}
    </div>
  );
}
BannerFaqs.propTypes = {
  faqdetails: PropTypes.array,
  bannerData: PropTypes.object,
  setBannerData: PropTypes.func,
  searchQuestion: PropTypes.string,
  handleSearchFaq: PropTypes.func,
  hLinkResp: PropTypes.string,
  setHLinkResp: PropTypes.func,
  activeIndex: PropTypes.number,
  setActiveIndex: PropTypes.func,
  projectId: PropTypes.string,
  handleBannerRedirection: PropTypes.func,
};
